import React from 'react';
import {
	View,
	StyleSheet,
	TouchableOpacity,
	useWindowDimensions,
	Modal,
} from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import I18n from '../../i18n/I18n.component';
import Typography from '../../Typography/Typography.component';
import colors from '../../../../config/colors';
import CompleteEntryContainer from './CompleteEntryModal.container';

interface Props {
	visible: boolean;
	sheetProps: any;
	onClose: () => void;
}

const CompleteEntryBottomSheet = ({ visible, sheetProps, onClose }: Props) => {
	const { height: windowHeight } = useWindowDimensions();
	const { bottom: bottomInset } = useSafeAreaInsets();


	if (!visible && !sheetProps) return null;

	return (
		<Modal
			visible={visible}
			transparent
			animationType='slide'
			statusBarTranslucent
			onRequestClose={onClose}
		>
			<TouchableOpacity
				activeOpacity={1}
				onPress={onClose}
				style={styles.backdrop}
			/>
			<View style={[styles.sheetPanel, { height: windowHeight * 0.9, paddingBottom: bottomInset + 20 }]}>
				<View style={styles.header}>
					<View style={styles.handleBar} />
					<View style={styles.titleRow}>
						<TouchableOpacity
							onPress={onClose}
							hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
						>
							<Typography size={18} color='darkGrey'>
								✕
							</Typography>
						</TouchableOpacity>
						<View style={styles.titleTextRow}>
							<I18n
								font='medium'
								size={14}
								color='primaryDarkBlue'
								style={{ letterSpacing: 0.15, marginLeft: 12 }}
							>
								general.reportExit
							</I18n>
							{sheetProps?.prevValues?.date ? (
								<Typography
									size={14}
									weight='400'
									color='primaryDarkBlue'
									style={{ letterSpacing: 0.25 }}
								>
									{`   ${sheetProps.prevValues.date}`}
								</Typography>
							) : null}
						</View>
						<View style={{ width: 24 }} />
					</View>
				</View>
				<View style={[styles.content]}>
					{sheetProps ? (
						<CompleteEntryContainer
							{...sheetProps}
							onCancel={(callback: Function) => {
								sheetProps.onCancel(callback);
								onClose();
							}}
							onSubmit={async (callback: Function, date: string) => {
								try {
									await sheetProps.onSubmit(callback, date);
								} finally {
									onClose();
								}
							}}
						/>
					) : null}
				</View>
			</View>
		</Modal>
	);
};

const styles = StyleSheet.create({
	sheetPanel: {
		position: 'absolute',
		bottom: 0,
		left: 0,
		right: 0,
		backgroundColor: colors.white,
		borderTopLeftRadius: 20,
		borderTopRightRadius: 20,
	},
	header: {
		backgroundColor: colors.white,
		borderTopLeftRadius: 20,
		borderTopRightRadius: 20,
		paddingTop: 10,
		paddingHorizontal: 20,
		paddingBottom: 12,
		borderBottomWidth: 1,
		borderBottomColor: '#F0F0F0',
	},
	handleBar: {
		width: 40,
		height: 4,
		borderRadius: 2,
		backgroundColor: '#D1D4DC',
		alignSelf: 'center',
		marginBottom: 12,
	},
	titleRow: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	titleTextRow: {
		flexDirection: 'row-reverse',
		alignItems: 'center',
		justifyContent: 'center',
		flex: 1,
	},
	content: {
		flex: 1,
		backgroundColor: colors.white,
		paddingHorizontal: 20,
		paddingTop: 16,
	},
	backdrop: {
		...StyleSheet.absoluteFillObject,
		backgroundColor: 'rgba(0, 0, 0, 0.4)',
	},
});

export default CompleteEntryBottomSheet;
